import {
  Icon,
  IconPrivacyOptionsDefault,
  IconLogoDefault,
  Separator,
} from '@mc/design-system'
import { isGeo } from '@mc/geo'
import { useTranslation } from '@mc/i18n'
import Link from 'components/Link'
import {
  caPrivacyPath,
  doNotSellPath,
  homePath,
  privacyPath,
  termsPath,
} from 'libs/paths'
import { trackNavigationClick } from './events/footerNavigationEvents'

const copyrightInfo = `\u00A9 ${new Date().getFullYear()} MasterClass`

export const SimplifiedFooter = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <Separator />
      <div className='container mc-mb-md-2 mc-mb-12'>
        <footer className='row align-items-baseline mc-text-small'>
          <div className='col-12 col-lg-6'>
            <div className='d-flex flex-column flex-lg-row align-items-center'>
              <Link
                href={homePath()}
                passHref
                onClick={() => trackNavigationClick('MC Logo')}
              >
                <IconLogoDefault
                  className='mc-mb-3 mc-mb-md-0 mc-mr-md-4'
                  size={6}
                  srText={t('footer.logo')}
                />
              </Link>

              <div className='d-flex align-items-center mc-opacity--muted'>
                <p className='mc-mr-4'>{copyrightInfo}</p>
                <p className='d-flex align-items-center'>
                  <Icon className='mc-icon--3' kind='locked' />
                  <span>{t('footer.secured')}</span>
                </p>
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-6'>
            <div className='row mc-text--center mc-text--lg-left justify-content-md-end'>
              <div className='col-12 col-lg-auto'>
                <Link
                  href={privacyPath()}
                  className='mc-text--bare-link'
                  passHref
                  onClick={() =>
                    trackNavigationClick(t('footer.columns.about.privacy'))
                  }
                >
                  {t('footer.columns.about.privacy')}
                </Link>
              </div>

              {isGeo('US') && (
                <>
                  <div className='col-12 col-lg-auto'>
                    <Link
                      href={caPrivacyPath()}
                      className='mc-text--bare-link'
                      passHref
                      onClick={() =>
                        trackNavigationClick(
                          t('footer.columns.about.caPrivacy'),
                        )
                      }
                    >
                      {t('footer.columns.about.caPrivacy')}
                    </Link>
                  </div>
                  <div className='col-12 col-lg-auto'>
                    <Link
                      href={doNotSellPath()}
                      className='mc-text--bare-link'
                      passHref
                      onClick={() =>
                        trackNavigationClick(
                          t('footer.columns.about.doNotSell'),
                        )
                      }
                    >
                      {t('footer.columns.about.doNotSell')}
                      <IconPrivacyOptionsDefault
                        size='lg'
                        className='mc-overflow--visible mc-ml-1'
                        width='30'
                        height='15'
                        viewBox='0 0 30 15'
                      />
                    </Link>
                  </div>
                </>
              )}
              <div className='col-12 col-lg-auto'>
                <Link
                  href={termsPath()}
                  className='mc-text--bare-link'
                  passHref
                  onClick={() =>
                    trackNavigationClick(t('footer.columns.about.terms'))
                  }
                >
                  {t('footer.columns.about.terms')}
                </Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}
